import { Link } from 'react-router-dom';
import styles from '../css/Footer.module.css';
import { appVersion } from '../version';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}></div>

      <div className={styles.footerContainer}>
        <div className={styles.grid}>

          {/* Бренд */}
          <div className={styles.tile}>
            <h3 className={styles.brand}>DoramaHype</h3>
            <p className={styles.brandDesc}>
              Любимые дорамы с русской озвучкой — всегда рядом
            </p>
            <div className={styles.socialLinks}>
              <button className={styles.socialLink} aria-label="Telegram">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
                </svg>
              </button>
              <button className={styles.socialLink} aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </button>
              <button className={styles.socialLink} aria-label="VK">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.344 16.163h-1.867c-.678 0-.886-.438-2.103-1.67-1.06-1.04-1.527-1.182-1.793-1.182-.365 0-.468.103-.468.598v1.526c0 .412-.133.662-1.228.662-1.812 0-3.821-1.096-5.235-3.138-2.117-3.029-2.693-5.316-2.693-5.78 0-.264.103-.51.598-.51h1.867c.448 0 .618.206.792.685.878 2.56 2.344 4.805 2.948 4.805.229 0 .332-.105.332-.685v-2.665c-.069-1.134-.663-1.229-.663-1.633 0-.213.172-.423.448-.423h2.935c.375 0 .515.206.515.649v3.598c0 .375.168.515.274.515.229 0 .425-.14.856-.571 1.325-1.487 2.275-3.783 2.275-3.783.125-.271.329-.51.778-.51h1.867c.56 0 .683.286.56.675-.206.927-2.26 4.354-2.26 4.354-.193.309-.265.446 0 .788.196.253.843.826 1.277 1.324.783.903 1.384 1.657 1.546 2.182.166.524-.092.788-.605.788z"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Информация */}
          <div className={styles.tile}>
            <h4 className={styles.tileTitle}>Информация</h4>
            <ul className={styles.tileLinks}>
              <li><Link to="/about">О сайте</Link></li>
              <li><Link to="/privacy">Политика конфиденциальности</Link></li>
              <li><Link to="/copyright">DMCA / Правообладателям</Link></li>
              <li><Link to="/advertise">Рекламодателям</Link></li>
            </ul>
          </div>

        </div>

        {/* Копирайт */}
        <div className={styles.tileBottom}>
          <p className={styles.copyright}>© 2026 DoramaHype — все права защищены</p>
          <p className={styles.version}>{appVersion}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
